// countryhelper.js
const CountryList = [
  { countryName: "UNITED STATES", iso2: "US", iso3: "USA" },
  { countryName: "CANADA", iso2: "CA", iso3: "CAN" },
  { countryName: "MEXICO", iso2: "MX", iso3: "MEX" },
];

const DefaultCountry = CountryList[0].iso3;

function mapCountryStringToObject(countryStr) {
  if (!countryStr) return null;
  const input = countryStr.trim().toUpperCase();
  return (
    CountryList.find(
      (c) =>
        c.countryName.toUpperCase() === input ||
        c.iso2.toUpperCase() === input ||
        c.iso3.toUpperCase() === input
    ) || { CountryName: countryStr, iso2: countryStr, iso3: countryStr, invalid: 1 }
  );
}

export default {
  CountryList,
  DefaultCountry,
  mapCountryStringToObject,
};